// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__3T743","row":"Node_row__1XvkO","label":"Node_label__bTvbe","footer":"Node_footer__FlChQ"};